export function deviceIsDesktop() {
  // return true;
  return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
}
